// =============================================================================
// Contact form.
//
// The mockup validates in the browser and prints one status line, green on
// success and red otherwise. The same wording now comes back from PHP, which
// also sends the mail — so the message shown is the real outcome rather than an
// optimistic guess.
// =============================================================================

const settings = window.chengHua || {};

export default function initContactForm() {
	document.querySelectorAll('[data-ch-contact]').forEach((form) => {
		const status = form.querySelector('[data-ch-contact-status]');
		const submit = form.querySelector('[type="submit"]');

		function show(message, ok) {
			if (!status) {
				return;
			}

			status.textContent = message;
			status.classList.toggle('is-ok', ok);
			status.hidden = message === '';
		}

		form.addEventListener('submit', async (event) => {
			if (!settings.ajaxUrl) {
				// Without the endpoint URL the plain POST is the better outcome.
				return;
			}

			event.preventDefault();

			const body = new FormData(form);

			// The inline nonce is fresher than the one rendered into the page,
			// which matters on a cached page whose printed nonce has expired.
			if (settings.contactNonce) {
				body.set('nonce', settings.contactNonce);
			}

			if (submit) {
				submit.disabled = true;
			}

			try {
				const response = await fetch(settings.ajaxUrl, {
					method: 'POST',
					credentials: 'same-origin',
					body,
				});
				const payload = await response.json();
				const message = payload?.data?.message || '';

				show(message, Boolean(payload?.success));

				if (payload?.success) {
					form.reset();
				}
			} catch {
				// Wording comes from the markup so it stays translatable.
				show(status?.dataset.chFallback || '', false);
			} finally {
				if (submit) {
					submit.disabled = false;
				}
			}
		});
	});
}
